<template>

  <div class="completed-request">

    <h2>Thank You!</h2>

    <p>Your request has been submitted. We will get back to you soon.</p>

    <div v-if="message" class="submitted-message">
      <h3>Your Message:</h3>
      <p>{{ message }}</p>
    </div>
    <!--    <button @click="$emit('reset')">Submit Another Request</button>-->

  </div>

</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style scoped>

.completed-request {
  text-align: center;
  max-width: 400px;
  margin: 0 auto;
}

button {
  padding: 10px;
  background: #28a745;
  color: white;
  border: none;
  cursor: pointer;
}
</style>